import { Area, AreaChart, CartesianGrid, ResponsiveContainer, ReferenceLine, Tooltip, XAxis, YAxis } from "recharts";
import type { NormalizedCandle, Signal } from "@tradesignal/core";

export function ChartCard({ candles, signal }: { candles?: NormalizedCandle[]; signal?: Signal }) {
  if (!candles?.length) {
    return (
      <section className="glass-card rounded-[2rem] p-5">
        <h2 className="text-lg font-extrabold">Price chart</h2>
        <p className="mt-3 text-sm leading-6 text-slate-400">
          No usable market data is cached for this symbol. Import CSV data or wait for the next successful provider scan.
        </p>
      </section>
    );
  }

  const data = candles.slice(-70).map((candle) => ({
    date: new Date(candle.t).toLocaleDateString(undefined, { month: "short", day: "numeric" }),
    close: candle.c
  }));

  return (
    <section className="glass-card rounded-[2rem] p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-lg font-extrabold">Price chart</h2>
        <span className="text-xs font-bold text-slate-400">{signal?.dataSource ?? "Mock cache"}</span>
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 8, right: 4, bottom: 0, left: -24 }}>
            <defs>
              <linearGradient id="priceFill" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor="#7c3aed" stopOpacity={0.45} />
                <stop offset="100%" stopColor="#7c3aed" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#283149" strokeDasharray="3 6" vertical={false} />
            <XAxis dataKey="date" tick={{ fill: "#94a3b8", fontSize: 10 }} tickLine={false} axisLine={false} interval="preserveStartEnd" />
            <YAxis tick={{ fill: "#94a3b8", fontSize: 10 }} tickLine={false} axisLine={false} domain={["dataMin", "dataMax"]} />
            <Tooltip contentStyle={{ background: "#101522", border: "1px solid #283149", borderRadius: 16 }} />
            {signal ? (
              <>
                <ReferenceLine y={signal.entry} stroke="#f8fafc" strokeDasharray="4 4" />
                <ReferenceLine y={signal.stopLoss} stroke="#fb7185" strokeDasharray="4 4" />
                <ReferenceLine y={signal.target1} stroke="#34d399" strokeDasharray="4 4" />
              </>
            ) : null}
            <Area type="monotone" dataKey="close" stroke="#a78bfa" strokeWidth={3} fill="url(#priceFill)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
